import React, { useEffect, useRef } from 'react';
import { makeBrandedQr } from '../utils/brandedQr';

/**
 * BrandedQR — the Portal disco-ball QR, rendered live (Phase 12). Scannable
 * (error-correction H + small logo). Use for a standalone QR the host can show /
 * screenshot / print. For embedding into a generated image, use brandedQrImage().
 */
export default function BrandedQR({ value, size = 220, className = '', style }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !value) return undefined;
    el.innerHTML = '';
    try {
      makeBrandedQr(value, size).append(el);
    } catch { /* qr render failed — leave empty */ }
    return () => { if (el) el.innerHTML = ''; };
  }, [value, size]);

  return <div ref={ref} className={className} style={{ width: size, height: size, ...style }} aria-label="QR code" />;
}
